import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

// this is also called a Tooltip

// i only say it bc its not the first time i forget
// how the fuck i called this and try to `grep` and `find` it
// and it drives me mad

const HoverTip = ({ children, text }) => (
  <OverlayTrigger
    placement="top"
    overlay={ <Tooltip style={{ fontSize: 15 }} id={text}>{text}</Tooltip> }
  >
    {children}
  </OverlayTrigger>
)

export default HoverTip
